import * as React from 'react';
import * as _ from 'lodash';
import useNavigate from 'react-router-dom'
import { IApplicationState, RecipientActionCreators, AppActionCreators, IRecipientDataResponse, IEnrollmentRequest, IRecipientShieldLookupResponse } from '@nkr/store/index';
import { Dispatch, connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as moment from "moment"

import { IListItem, IBaseResponse } from "@nkr/models/index";
import { FormGroup, Col, FormControl, Row, ControlLabel, Radio, Button, Panel, Checkbox, ProgressBar, Modal } from "react-bootstrap";
import { State } from '@nkr/enums/state';
import { IAppState } from "@nkr/store/index";
import EnrollmentInfo from './components/enrollment-info';
import RecipientInfo from './components/recipient-information';
import RecipientAddressInfo from './components/recipient-address-info';
import OrderingPhysician from './components/ordering-physician';
import InsuranceInformation from './components/insurance-information';
import EnrollmentConfirmation from './components/enrollment-confirmation';
import { ThemeProvider } from 'styled-components';

interface IProps {
    centerId: number,
    recipientId: number
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getRecipientShieldLookup: (centerId: number) => Promise<IRecipientShieldLookupResponse>,
    getRecipientData: (recipientId: number) => Promise<IRecipientDataResponse>,
    addEnrollment: (centerId: number, recipientId: number, request: IEnrollmentRequest) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    [index: string]: string | Boolean | IListItem[] | number | boolean
    recpFirstName: string,
    recpLastName: string,
    recpAddress: string,
    recpCity: string,
    recpZipCode: string,
    recpState: string,
    recpDob: string,
    recpRecentTransplantDate: string,
    recpHasRecentTransplant: boolean,

    recpMedicareNumber: string,
    recpGender: string,
    recpParentChildTransplant: boolean,
    recpMrn: string,
    recpIcdCode: string,

    physFirstName: string,
    physLastName: string,
    physAddress: string,
    physCity: string,
    physZipCode: string,
    physState: string,
    physNpiNumber: string,

    testTypes: IListItem[],
    months1: boolean,
    months3: boolean,
    months6: boolean,
    months12: boolean,
    months18: boolean,
    months24: boolean,

    orderTypeId: number,
    currentStep: number,
    currentStepPercent: number,
    currentStepTitle: string,

    showConfirmationModal: boolean
}

class RsEnroll extends React.Component<TProps, IState> {
    readonly state: IState = {
        recpFirstName: '',
        recpLastName: '',
        recpAddress: '',
        recpCity: '',
        recpZipCode: '',
        recpState: '',
        recpDob: '',
        recpGender: '',
        recpParentChildTransplant: false,
        recpHasRecentTransplant: false,
        recpRecentTransplantDate: '',
        recpPolicyHolderName: '',
        recpMrn: '',
        recpIcdCode: '',
        recpMedicareNumber: '',

        physFirstName: '',
        physLastName: '',
        physAddress: '',
        physCity: '',
        physZipCode: '',
        physState: '',
        physNpiNumber: '',
        testTypes: [],
        months1: false,
        months3: false,
        months6: false,
        months12: false,
        months18: false,
        months24: false,

        orderTypeId: 0,
        currentStep: 1,
        currentStepPercent: 20,
        currentStepTitle: 'Enrollment Information',
        showConfirmationModal: false
    }



    componentDidMount = () => {
        this.getData();
    }

    handleInputChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    handleRecentTransplantToggle = () => {
        this.setState({
            recpHasRecentTransplant: !this.state.recpHasRecentTransplant
        });
    }

    handleCheckboxChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;

        var value = false;
        switch (name) {
            case "months1":
                value = !this.state.months1;

                break;
            case "months3":
                value = !this.state.months3;
                break;

            case "months6":
                value = !this.state.months6;
                break;

            case "months12":
                value = !this.state.months12;
                break;

            case "months18":
                value = !this.state.months18;
                break;

            case "months24":
                value = !this.state.months24;
                break;
        }


        this.setState({
            [name]: value
        });
    }

    enrollRecipient = () => {

        var enrollment = {
            recpFirstName: this.state.recpFirstName,
            recpLastName: this.state.recpLastName,
            recpAddress: this.state.recpAddress,
            recpCity: this.state.recpCity,
            recpState: this.state.recpState,
            recpZipCode: this.state.recpZipCode,
            recpDob: this.state.recpDob,
            recpGender: this.state.recpGender,
            recpRecentTransplantDate: moment(this.state.recpRecentTransplantDate).isValid() ? this.state.recpRecentTransplantDate : "",
            recpMedicareNumber: this.state.recpMedicareNumber,
            recpPrimaryInsurance: this.state.recpPrimaryInsurance,
            recpIcdCode: this.state.recpIcdCode,
            parentChildTransplant: this.state.recpParentChildTransplant,
            recpMrn: this.state.recpMrn,

            physFirstName: this.state.physFirstName,
            physLastName: this.state.physLastName,
            physAddress: this.state.physAddress,
            physCity: this.state.physCity,
            physState: this.state.physState,
            physZipCode: this.state.physZipCode,
            physNpiNumber: this.state.physNpiNumber,

            orderTypeId: this.state.orderTypeId,

            months1: this.state.months1,
            months3: this.state.months3,
            months6: this.state.months6,
            months12: this.state.months12,
            months18: this.state.months18,
            months24: this.state.months24

        } as IEnrollmentRequest;

        this.props.showLoading("Enrolling recipient, one moment please...").then(() => {
            this.props.addEnrollment(this.props.centerId, this.props.recipientId, enrollment)
                .then(async (response) => {
                    if (response.data.success) {
                        var url = `center/${this.props.centerId}/recipients`;
                        toast.success("Enrollment complete.  You will now be redirected to the recipients list...");

                        await sleep(3000);

                        window.open(url, '_self');
                    } else {
                        toast.error("Unable to complete enrollment");
                    }

                    this.props.hideLoading();
                }).catch(() => {
                    this.props.hideLoading();
                });
        });

    }

    prevStep = () => {

        let title = '';
        let currentStep = this.state.currentStep - 1;

        if (currentStep == 0)
            return;

        switch (currentStep) {
            case 1:
                title = 'Enrollment Information';
                break;
            case 2:
                title = 'Recipient Information'
                break;
            case 3:
                title = 'Recipient Address Information'
                break;
            case 4:
                title = 'Ordering Physician Information'
                break;
            case 5:
                title = 'Confirmation'
                break;
        }

        this.setState({
            currentStep: currentStep,
            currentStepPercent: (currentStep / 5) * 100,
            currentStepTitle: title

        });
    }

    nextStep = () => {

        let title = '';

        let currentStep = this.state.currentStep + 1;

        if (currentStep <= 5) {
            //handle validation
            var errors = [];
            switch (currentStep) {
                case 1:
                    title = 'Enrollment Information'
                    break;
                case 2:
                    //validate enrollment information
                    if (this.state.orderTypeId == 0)
                        errors.push("Order Type");

                    if (!this.state.months1 && !this.state.months3 && !this.state.months6 && !this.state.months12 && !this.state.months18 && !this.state.months24)
                        errors.push("Month After Surgery Testing");

                    title = 'Recipient Information'
                    break;
                case 3:
                    //validate mrn
                    if (this.state.recpMrn.length == 0)
                        errors.push("MRN #");

                    //validate firstName
                    if (this.state.recpFirstName.length == 0)
                        errors.push("First Name");

                    //validate lastName
                    if (this.state.recpLastName.length == 0)
                        errors.push("Last Name");

                    //validate gender
                    if (this.state.recpGender != "M" && this.state.recpGender != "F")
                        errors.push("Gender");

                    //validate date of birth
                    if (!moment(this.state.recpDob).isValid())
                        errors.push("Date of Birth");

                    //validate recent transplant
                    if (this.state.recpHasRecentTransplant && !moment(this.state.recpRecentTransplantDate).isValid())
                        errors.push("Recent Transplant");

                    //validate Medicare number
                    if (this.state.recpMedicareNumber.length == 0)
                        errors.push("Medicare Number");

                    title = 'Recipient Address Information'
                    break;
                case 4:

                    //validate recipient information
                    if (this.state.recpAddress.length == 0)
                        errors.push("Address");

                    if (this.state.recpState.length == 0)
                        errors.push("State");

                    if (this.state.recpZipCode.length == 0)
                        errors.push("Postal Code");

                    if (this.state.recpIcdCode.length == 0)
                        errors.push("Type");

                    //validate recp address information
                    title = 'Ordering Physician Information'
                    break;
                case 5:
                    if (this.state.physFirstName.length == 0)
                        errors.push("First Name");

                    if (this.state.physLastName.length == 0)
                        errors.push("Last Name");

                    if (this.state.physAddress.length == 0)
                        errors.push("Address");

                    if (this.state.physCity.length == 0)
                        errors.push("City");

                    if (this.state.physState.length == 0)
                        errors.push("State");

                    if (this.state.physZipCode.length == 0)
                        errors.push("Postal Code");

                    if (this.state.physNpiNumber.length == 0)
                        errors.push("NPI Number");
                    break;
            }

            //error handling via toast
            if (errors.length > 0) {
                var errStr = "";
                for (var i = 0; i < errors.length; i++) {
                    if (i == 0) {
                        errStr += errors[i];
                    } else {
                        errStr += ", " + errors[i]
                    }
                }

                toast.error("The following fields are required to continue: " + errStr);
                return;
            }

            if (currentStep == 5)
                this.setState({
                    showConfirmationModal: true
                });
            else
                this.setState({
                    currentStep: currentStep,
                    currentStepPercent: (currentStep / 4) * 100,
                    currentStepTitle: title,
                });

        }
    }

    getData = async () => {
        this.props.showLoading("Getting Recipient Shield Information, one moment please....").then(() => {
            Promise.all([
                //get recipient Address information
                //get lookupData
                //Test Types List
                //states list
                this.props.getRecipientShieldLookup(this.props.centerId),
                this.props.getRecipientData(this.props.recipientId)
            ])
                .then(([rsLookupResponse, recpDataResponse]) => {

                    if (recpDataResponse.data.success) {
                        var recpData = recpDataResponse.data.results;
                        let content = recpData;
                        //get list of types

                        let defaultTests = rsLookupResponse.data.results.defaultTestCycles;
                        let testTypes = rsLookupResponse.data.results.testTypes;
                        this.setState({
                            recpFirstName: content.firstName,
                            recpLastName: content.lastName,
                            recpAddress: content.phiAddress,
                            recpCity: content.phiCity,
                            recpState: content.phiState,
                            recpZipCode: content.phiPostalCode,
                            recpGender: content.gender,
                            recpDob: moment(content.birthDate).format("YYYY-MM-DD"),

                            testTypes: testTypes,
                            months1: defaultTests == null ? false : defaultTests.months1,
                            months3: defaultTests == null ? false : defaultTests.months3,
                            months6: defaultTests == null ? false : defaultTests.months6,
                            months12: defaultTests == null ? false : defaultTests.months12,
                            months18: defaultTests == null ? false : defaultTests.months18,
                            months24: defaultTests == null ? false : defaultTests.months24,

                            //insurance information
                            recpPrimaryInsurance: content.insurance.primaryGroupName,
                            recpInsPolicyHolderName: content.insurance.subscriberName != "" ? content.insurance.patientName : content.insurance.subscriberName,
                            recpInsGroupId: content.insurance.primaryGroupId,
                            recpInsRelationship: content.insurance.relationshipToSubscriber,
                            recpPolicyHolderName: content.insurance.patientName,
                            recpInsDob: moment(content.birthDate).format("YYYY-MM-DD"),
                            recpRecentTransplantDate: moment(this.state.recpRecentTransplantDate).format("YYYY-MM-DD"),
                        }, () => {
                            this.props.hideLoading();
                        });
                    }

                    //set lookup Data (State, Test Type)
                    //set current address (Recipient Phi data)
                    //validate address (validate data inputted)
                    //do not let submit be clickable until validated


                }).catch(() => {
                    this.props.hideLoading();
                })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleGenderSelect = (gender: boolean) => {
        this.setState({
            recpGender: gender ? "M" : "F"
        });
    };

    handleInsGenderSelect = (gender: boolean) => {
        this.setState({
            recpInsGender: gender ? "M" : "F"
        });
    };

    handleParentChildTransplantSelect = (status: boolean) => {
        this.setState({
            recpParentChildTransplant: status
        });
    };

    handleOrderType = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {

        this.setState({
            orderTypeId: parseInt(e.currentTarget.value)
        });
    }

    handleIcdType = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {

        this.setState({
            recpIcdCode: e.currentTarget.value
        });
    }

    handleModalClose = () => {
        this.setState({
            showConfirmationModal: false
        });
    }

    render = () => {

        return (
            <div style={{ padding: '0px 5px' }}>
                <div style={{ marginTop: 10 }}>
                    <Row style={{ marginLeft: 50, marginBottom: 20 }}>
                        <Col sm={8} smPush={2}>

                            <Row>
                                <h3>Recipient Shield Enrollment</h3>
                            </Row>
                            <div className='col-sm-12' style={{ border: '1px solid black', minHeight: '450' }}>
                                <Row>
                                    <div style={{ height: "400px" }}>
                                        <Panel bsStyle="info">
                                            <Panel.Heading>
                                                <h4>{this.state.currentStepTitle}</h4>
                                                <ProgressBar bsStyle="primary" style={{ borderRadius: '0px', marginBottom: '0px' }} now={this.state.currentStepPercent} label={'Progress: ' + this.state.currentStep + ' / 4'} />
                                            </Panel.Heading>

                                            <Panel.Body>

                                                {/* Enrollment Information */}
                                                {this.state.currentStep == 1
                                                    ? <EnrollmentInfo
                                                        months1={this.state.months1}
                                                        months3={this.state.months3}
                                                        months6={this.state.months6}
                                                        months12={this.state.months12}
                                                        months18={this.state.months18}
                                                        months24={this.state.months24}
                                                        orderTypeId={this.state.orderTypeId}
                                                        testTypes={this.state.testTypes}
                                                        handleCheckboxChange={this.handleCheckboxChange}
                                                        handleOrderType={this.handleOrderType}
                                                    />
                                                    : ''}

                                                {/* Recipient Information */}
                                                {this.state.currentStep == 2
                                                    ? <RecipientInfo
                                                        recpMrn={this.state.recpMrn}
                                                        recpFirstName={this.state.recpFirstName}
                                                        recpLastName={this.state.recpLastName}
                                                        recpGender={this.state.recpGender}
                                                        recpMedicareNumber={this.state.recpMedicareNumber}
                                                        recpDob={this.state.recpDob}
                                                        recpRecentTransplantDate={this.state.recpRecentTransplantDate}
                                                        recpHasRecentTransplant={this.state.recpHasRecentTransplant}
                                                        handleGenderSelect={this.handleGenderSelect}
                                                        handleInputChange={this.handleInputChange}
                                                        handleRecentTransplantToggle={this.handleRecentTransplantToggle}

                                                    />
                                                    : ''}

                                                {/* Recipient Address Information */}
                                                {this.state.currentStep == 3
                                                    ? <RecipientAddressInfo
                                                        recpAddress={this.state.recpAddress}
                                                        recpCity={this.state.recpCity}
                                                        recpState={this.state.recpState}
                                                        recpZipCode={this.state.recpZipCode}
                                                        recpIcdCode={this.state.recpIcdCode}
                                                        recpMedicareNumber={this.state.recpMedicareNumber}
                                                        recpParentChildTransplant={this.state.recpParentChildTransplant}
                                                        handleIcdType={this.handleIcdType}
                                                        handleParentChildTransplantSelect={this.handleParentChildTransplantSelect}
                                                        handleInputChange={this.handleInputChange}
                                                    />
                                                    : ''}

                                                {/* Ordering Physician */}
                                                {this.state.currentStep == 4
                                                    ? <OrderingPhysician
                                                        physFirstName={this.state.physFirstName}
                                                        physLastName={this.state.physLastName}
                                                        physAddress={this.state.physAddress}
                                                        physCity={this.state.physCity}
                                                        physState={this.state.physState}
                                                        physZipCode={this.state.physZipCode}
                                                        physNpiNumber={this.state.physNpiNumber}
                                                        handleInputChange={this.handleInputChange}
                                                    />
                                                    : ''}

                                                {/* Insurance Information */}
                                                {/* {this.state.currentStep == 5 
                                                ? <InsuranceInformation 
                                                    recpInsPrimaryInsurance={this.state.recpInsPrimaryInsurance}
                                                    recpInsPolicyHolderName={this.state.recpInsPolicyHolderName}
                                                    recpInsPolicyNumber={this.state.recpInsPolicyNumber}
                                                    recpInsGroupId={this.state.recpInsGroupId}
                                                    recpInsRelationship={this.state.recpInsRelationship}
                                                    recpInsGender={this.state.recpInsGender}
                                                    recpInsDob={this.state.recpInsDob}
                                                    handleInsGenderSelect={this.handleInsGenderSelect}
                                                    handleInputChange={this.handleInputChange}
                                                    />
                                                : ''} */}

                                            </Panel.Body>
                                        </Panel>
                                    </div>
                                </Row>

                                <Row style={{ bottom: 0, left: 0, marginTop: '10px' }}>
                                    <Col sm={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                        <Button className='btn-block' bsStyle="primary" style={{ height: 50, borderRadius: 0 }} onClick={this.prevStep}>Prev</Button>
                                    </Col>

                                    <Col sm={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                        <Button className='btn-block' bsStyle="primary" style={{ height: 50, borderRadius: 0 }} onClick={this.nextStep}>Next</Button>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Modal show={this.state.showConfirmationModal} onHide={this.handleModalClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <EnrollmentConfirmation
                            orderTypeId={this.state.orderTypeId}
                            testTypes={this.state.testTypes}

                            months1={this.state.months1}
                            months3={this.state.months3}
                            months6={this.state.months6}
                            months12={this.state.months12}
                            months18={this.state.months18}
                            months24={this.state.months24}

                            recpFirstName={this.state.recpFirstName}
                            recpLastName={this.state.recpLastName}
                            recpMrn={this.state.recpMrn}
                            recpGender={this.state.recpGender}
                            recpDob={this.state.recpDob}
                            recpRecentTransplantDate={this.state.recpRecentTransplantDate}
                            recpMedicareNumber={this.state.recpMedicareNumber}

                            recpAddress={this.state.recpAddress}
                            recpCity={this.state.recpCity}
                            recpState={this.state.recpState}
                            recpPostalCode={this.state.recpZipCode}

                            physFirstName={this.state.physFirstName}
                            physLastName={this.state.physLastName}
                            physAddress={this.state.physAddress}
                            physCity={this.state.physCity}
                            physState={this.state.physState}
                            physPostalCode={this.state.physZipCode}
                            physNpi={this.state.physNpiNumber}
                        />
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={this.handleModalClose}>Cancel</Button>
                        <Button bsStyle="primary" onClick={this.enrollRecipient}>Confirm Enrollment</Button>
                    </Modal.Footer>
                </Modal>

            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    }
}
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getRecipientShieldLookup: (centerId) => {
            return dispatch(RecipientActionCreators.getRecipientShieldLookup(centerId));
        },
        getRecipientData: (recpId) => {
            return dispatch(RecipientActionCreators.getRecipientData(recpId));
        },
        addEnrollment: (centerId, recpId, request) => {
            return dispatch(RecipientActionCreators.addEnrollment(centerId, recpId, request));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps, mapDispatchToProps)(RsEnroll)